import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  Renderer2,
  ViewEncapsulation
} from '@angular/core';
import { WindowService } from 'src/vendor/window/window.service';
import { WindowRef } from 'src/vendor/window/window.component';
import { environment } from '@environments/environment';
import { AppService } from './app.service';
import { AuthService } from '@core/state/auth/auth.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'ihd-app',
  templateUrl: './app.component.html',
  styleUrls: [
    './app.component.scss',
    '../styles/index.scss'
  ],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'c-app'
  }
})
export class AppComponent implements OnInit, OnDestroy, AfterViewInit {

    private readonly URL_PARAM_ID_KEY: string = 'id';
    public showNavBar: boolean;

    private nativeWindow: Window;
    private destroyed$: Subject<void> = new Subject();

    constructor(private windowService: WindowService,
                private renderer: Renderer2,
                private appService: AppService,
                private authService: AuthService,
                private cdr: ChangeDetectorRef,
                private windowRef: WindowRef) {
        this.nativeWindow = windowRef.nativeWindow;
    }

    ngOnInit() {
        this.authService.isAuthenticated()
            .pipe(takeUntil(this.destroyed$))
            .subscribe((isAuthenticated: boolean) => {
                this.showNavBar = isAuthenticated;
                this.cdr.detectChanges();
            });
    }

    ngAfterViewInit() {
        this.appService.initApp();
    }

    ngOnDestroy() {
        this.destroyed$.next();
    }
}
